
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    ElHeader: () => import('./parts/header.vue'),
    ElFooter: () => import('./parts/footer.vue'),
    ChevronLeft: () => import('@/assets/svg/chevron-left.svg'),
  },
})
export default class Empty extends Vue {
  @Prop({ default: false }) readonly hasHeader!: boolean;

  @Prop({ default: 'default' }) readonly headerType!: string;

  @Prop({ default: '' }) readonly headerTitle!: string;

  @Prop({ default: false }) readonly hasFooter!: boolean;

  @Prop({ default: false }) readonly hideTopPadding!: boolean;

  @Prop({ default: false }) readonly hasAlternativeScroll!: boolean;

  @Prop({ default: 0 }) readonly alternativeScrollTop!: number;

  @Prop({ default: 'container' }) readonly containerClass!: string;

  @Prop({ default: '' }) readonly contentClass!: string;

  @Prop({ default: false }) canGoBack!: boolean;

  scrolled: boolean = false;

  private onScroll(e: Event, position: { scrollTop: number; scrollLeft: number }) {
    if (position.scrollTop > 10) {
      this.scrolled = true;
    } else {
      this.scrolled = false;
    }
  }

  @Watch('alternativeScrollTop')
  private onAlternativeScroll(newTop: number) {
    if (newTop > 10) {
      this.scrolled = true;
    } else {
      this.scrolled = false;
    }
  }
}
